import { BaseService } from "@/modules/Core/services/BaseService";
import type { ICitaOrdenesTecnologia, IResponseDispensacionesByOrden, IValidacionFormularioCups } from "../interfaces/tablas/ICitaOrdenesTecnologia";
import type { IResponseApi } from "@/modules/Core/interfaces";
import type { AxiosResponse } from "axios";
import type { ICitaDiagnostico } from "@/modules/Asistencial/interfaces";
import type { IOrigenAtencion } from "@/modules/Asistencial/interfaces/IOrigenAtencion";

export class OrdenesTecnologiaService extends BaseService<ICitaOrdenesTecnologia> {
    constructor () {
        super({
            baseUrl: 'scheduling/orders/'
        })
    }
    async createOrdenExterna<T> (
        data: T
    ): Promise<AxiosResponse<IResponseApi<ICitaOrdenesTecnologia>>> {
        return this.http.post<IResponseApi<ICitaOrdenesTecnologia>>(`/create-externa`, data)
            .catch(this.errorHandle)
    }
    async getOrderDetailsDispensations (
        params: Record<string, unknown>
    ): Promise<AxiosResponse<IResponseApi<IResponseDispensacionesByOrden[]>>> {
    return this.http
        .get<IResponseApi<IResponseDispensacionesByOrden[]>>(`/get-order-details-dispensations`, { params })
        .catch(this.errorHandle)
    }
    // Ver un elemento por ID
    async generales<T> (): Promise<AxiosResponse<IResponseApi<T>>> {
        return this.http.get<T>(`/generales`).catch(this.errorHandle)
    }
    async getOrdenByOrigenId (origenId: string | number, tipo: string): Promise<AxiosResponse<IResponseApi<ICitaOrdenesTecnologia>>> {
        return this.http.get<ICitaOrdenesTecnologia>(`/get-by-origen/${origenId}/${tipo}`).catch(this.errorHandle)
    }
    async getDiagnosticosBytechnologia (cittId: string | number): Promise<AxiosResponse<IResponseApi<ICitaDiagnostico[]>>> {
        return this.http.get<ICitaDiagnostico[]>(`/get-diagnostic-by-citt-id/${cittId}`).catch(this.errorHandle)
    }
    /** Origen de la atención, o null si no proviene de ninguna orden. */
    async getOrigenAtencion (cittId: string | number): Promise<AxiosResponse<IResponseApi<IOrigenAtencion | null>>> {
        return this.http.get<IResponseApi<IOrigenAtencion | null>>(`/origen-atencion/${cittId}`).catch(this.errorHandle)
    }
    async validateCupsFormulario (ciodId: string | number, cocuId: string | number, coseId?: number | null): Promise<AxiosResponse<IResponseApi<IValidacionFormularioCups>>> {
        return this.http.get<IResponseApi<IValidacionFormularioCups>>(`/validate-cups-formulario/${ciodId}/${cocuId}`, { params: { coseId } }).catch(this.errorHandle)
    }
  }
